// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_sXz","option":"styles_option__1kBH6","active":"styles_active__1zCY7"};